import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-chip',
  templateUrl: './status-chip.component.html',
  styleUrls: ['./status-chip.component.scss'],
})
export class StatusChipComponent {
  @Input() status?:
    | 'ACCEPTED'
    | 'APPROVED'
    | 'IN_PROGRESS'
    | 'PENDING'
    | 'REJECTED';

  @Input() label?: string;
}
